import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { Img } from '@shared/Frontend/components/img'
import { Clickable } from '@shared/Frontend/utils/clickable'
import { RichDownloadsBlockItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlockPaginator } from './blockPaginator'

export const RichDownloadsBlock: BlocksView['RichDownloadsBlock'] = (props) => {
  const { id, items, paginationSize } = props
  if (items?.length == 0) return <></>

  const { inView, ref } = useInView({ threshold: 0.1 })
  const [currentPage, setCurrentPage] = React.useState(1)

  const totalPages = Math.ceil(items.length / paginationSize)
  const visibleItems = items.slice((currentPage - 1) * paginationSize, currentPage * paginationSize)

  const onPageChange = (page: number) => {
    setCurrentPage(page)
    ref.current?.scrollIntoView()
  }

  return (
    <section id={id} ref={ref} className={cn('block block--brochures ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <h2 className='sr-text'>Onze brochures</h2>

        <div className="block__content">
          <ListLayout items={visibleItems} listClassName="brochure__list" />

          {totalPages > 1 && (
            <BlockPaginator currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
          )}
        </div>
      </div>
    </section>
  )
}

const ListLayout = (props: { items: RichDownloadsBlockItem[]; listClassName?: string }) => {
  return (
    <ul className={cn('list', props.listClassName)}>
      {props.items.map((item, index) => (
        <ItemLayout key={index} {...item} />
      ))}
    </ul>
  )
}

const ItemLayout = (props: RichDownloadsBlockItem) => {
  const { title, label, image, units } = props
  return (
    <li className={'brochure__item'}>
      <article className="brochure__article">
        <div className="brochure__visual" aria-hidden="true">
          {image && (
            <Img {...image} loading="lazy" className="brochure__image" width="192" height="273" sizes='(min-width: 768px) 192px, 96px' />
          )}
        </div>

          <div className="brochure__text">
            <header className="brochure__header ls-reversed-column">
              <h3 className="brochure__title title--sm">
                {title}
              </h3>

              {label && (
                <p className='brochure__label text--sm'>{label}</p>
              )}
            </header>

            <footer className="brochure__footer ls-clickables">
              {units.map((unit, index) => (
                <div className="ls-clickable" key={index}>
                  <Clickable
                    elementKind="link"
                    styleKind='button'
                    label={unit.title}
                    url={unit.url}
                    external={true}
                    download={unit.isDownload}
                    className={index === 0 ? 'block__clickable button' : 'block__clickable link link--hollow'}
                    hasBlob={true}
                    icon={'icon-chevron-right'}
                  />
                </div>
              ))}
            </footer>
          </div>
      </article>
    </li>
  )
}
